import React from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { HashRouter, Route } from "react-router-dom";
import Pricing from "./components/Pricing";
import Turbos from "./components/auth/Turbos";
import ReferralTurbo from "./components/auth/ReferralTurbo";

const App = () => {
  return (
    <HashRouter>
      <div className="App">
        <Route exact path="/" component={Pricing} />
        <Route exact path="/signup/" component={Turbos} />
    <Route
  exact
  path="/register/:referralId?"
  component={ReferralTurbo}
/>
        {/* <Route exact path="/sign-up" component={SignUp} />
                <Route exact path="/signup-turbo/:reference?" component={Turbos} />
                <Route exact path="/schedule/:reference?" component={Scheduler} /> */}
      </div>
    </HashRouter>
  );
};

export default App;
